import { render, staticRenderFns } from "./garden.vue?vue&type=template&id=5c7bfd34"
import script from "./garden.vue?vue&type=script&lang=js"
export * from "./garden.vue?vue&type=script&lang=js"
import style0 from "./garden.vue?vue&type=style&index=0&id=5c7bfd34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports